import styled from "@emotion/styled";
import {ReactComponent as airSvg} from "../../../../images/iconAir.svg";

export const AirSvg = styled(airSvg)`
    padding-top: 4px;
    fill: white;
`;